module.exports = __webpack_public_path__ + "img/classic_rental20_5.24f0d354.jpg";